import axios from 'axios'
import { authHeaders } from '../../utils/authHeaders'
import { handleStrapiAPIError } from '../../utils/handleStrapiAPIError'

const API_URL = process.env.REACT_APP_API_URL

/**
 * gets all the Answer Sessions as an array from BE
 * @return { sessions?:<array>, status?: <number>  }
 */
export const getAnswerSessions = async () => {
  try {
    const res = await axios.get(
      `${API_URL}/api/export-answer-sessions`,
      authHeaders(),
    )
    return { sessions: res.data?.sessions }
  } catch (error) {
    handleStrapiAPIError(error)
    return { status: error.response?.status }
  }
}

/**
 * gets all the current Benchmarks as an array from BE
 * @return { benchmarks?:<array>, status?: <number> }
 */
export const getBenchmarks = async () => {
  try {
    const res = await axios.get(
      `${API_URL}/api/export-benchmarks`,
      authHeaders(),
    )
    return { benchmarks: res.data?.benchmarks }
  } catch (error) {
    handleStrapiAPIError(error)
    return { status: error.response?.status }
  }
}
